module.exports = __webpack_public_path__ + "img/VSME Standard.ec2e5055.png";